<template>
  <ion-button
    @click="uploadOptions"
    fill="clear"
    color="medium"
    :class="isIOS() ? ' ' : '  photo_button_padding'"
    :disabled="photoPost.is_photo_post"
  >
    <ion-icon slot="icon-only" :icon="icon.attachOutline"></ion-icon>
  </ion-button>
</template>

<script>
import { attachOutline } from "ionicons/icons";

import { IonButton, IonIcon, popoverController } from "@ionic/vue";

import { defineComponent } from "vue";

import { isIOS } from "../../../services/utils";

import ChatMediaUploadOptions from "./ChatMediaUploadOptions.vue";

export default defineComponent({
  name: "ChatMediaUploadButton",
  props: ["post", "photoPost"],
  components: {
    IonButton,
    IonIcon,
  },
  data() {
    return {
      icon: {
        attachOutline,
      },
      popoverController,
    };
  },
  setup() {
    return { isIOS };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    async uploadOptions(ev) {
      const popover = await popoverController.create({
        component: ChatMediaUploadOptions,
        event: ev,
        translucent: true,
        cssClass: "userlist_popover",
      });

      popover.componentProps = {
        // post: this.post,
        parent: popover,
        photoPost: this.photoPost,
      };
      return popover.present();
    },
  },
});
</script>
